<template>
  <w-icon-wrapper icon-name='work-import-icon'>
    <g
      id='_24_Importieren_Icon'
      data-name='24 Importieren_Icon'
      transform='translate(0 0)'
    >
      <path
        id='Pfad_55693'
        d='M22,9.333V22H2V2H14.666a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H0V24H24V9.333a1,1,0,0,0-1-1h0A1,1,0,0,0,22,9.333Z'
        data-name='Pfad 55693'
        fill='currentColor'
      />
      <path
        id='Pfad_55694'
        d='M11.725,8.932a.975.975,0,0,0-1-.987A1.031,1.031,0,0,0,9.719,8.964l-.033,4.191a1.007,1.007,0,0,0,0,.11l-.008.984,5.3-.138a1.033,1.033,0,0,0,.7-.3,1.018,1.018,0,0,0,.3-.727.976.976,0,0,0-1-.977l-1.847.049L23.572,1.7A1,1,0,0,0,23.589.286,1,1,0,0,0,22.171.3l-10.46,10.46Z'
        data-name='Pfad 55694'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconImport' };
</script>
